export const residualDebtInsuranceDefaultValues = {
    applicant1: {
        death: {
            desired: false,
            existing: false,
            important: false,
        },
        unemployment: {
            desired: false,
            existing: false,
            important: false,
        },
        workIncapacity: {
            desired: false,
            existing: false,
            important: false,
        },
    },
    applicant2: {
        death: {
            desired: false,
            existing: false,
            important: false,
        },
        unemployment: {
            desired: false,
            existing: false,
            important: false,
        },
        workIncapacity: {
            desired: false,
            existing: false,
            important: false,
        },
    },
};
